import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes/Routers";
import "react-circular-progressbar/dist/styles.css";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CSSProperties } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NavigationProvider } from "./components/NavigationProvider";
import { NotificationProvider } from "./components/NotificationProvider";
import { UserDataProvider } from "./contexts/UserDataContext";

// Custom toast styles
const toastStyle: CSSProperties = {
  fontFamily: "Shabnam, system-ui, -apple-system, sans-serif",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "1.5",
  direction: "rtl" as const,
  textAlign: "right",
  zIndex: 9999,
};

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="">
        <BrowserRouter>
          <NotificationProvider>
            <NavigationProvider>
              <UserDataProvider>
                <Routes />
              </UserDataProvider>
            </NavigationProvider>
          </NotificationProvider>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={true}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            style={toastStyle}
            toastStyle={toastStyle}
          />
        </BrowserRouter>
      </div>
    </QueryClientProvider>
  );
}

// Keep QueryClient stable across renders (especially important under React.StrictMode)
const queryClient = new QueryClient();
